import {
  DEFAULT_PAGE,
  NUMBER_OF_SEARCH_RESULTS_PER_PAGE,
} from "../../NewSearchPageMVP.constants";
import { AgathaSchemaParamsEnum } from "../../types/IParametersSchema";
import { IUseFetchSearchResults } from "./useFetchSearchResults";

export const getQuerySearchParams = ({
  searchParams,
  searchId,
  canModifyContentSettings,
  sendAdminContentSettings,
}: Partial<IUseFetchSearchResults>) => {
  const newSearchParams = new URLSearchParams(searchParams);
  const page = searchParams?.get(AgathaSchemaParamsEnum.page) || DEFAULT_PAGE;
  // Set base params
  newSearchParams.set(AgathaSchemaParamsEnum.shape, "card");
  newSearchParams.set(AgathaSchemaParamsEnum.page, page);
  newSearchParams.set(
    AgathaSchemaParamsEnum.page_size,
    NUMBER_OF_SEARCH_RESULTS_PER_PAGE,
  );
  if (canModifyContentSettings && sendAdminContentSettings) {
    newSearchParams.set(AgathaSchemaParamsEnum.admin_content_settings, "true");
  }
  if (searchId?.length && Number(page) > 0)
    newSearchParams.set(AgathaSchemaParamsEnum.search_id, searchId);

  return newSearchParams;
};

export const mapSearchParamsToQueryString = (
  urlSearchParams: URLSearchParams,
) => {
  const params: { [key: string]: string } = {};
  for (const [key, value] of urlSearchParams.entries()) {
    if (params[key]) {
      params[key] = `${params[key] as string},${value}`;
    } else {
      params[key] = value;
    }
  }

  let qs = "";
  Object.entries(params).forEach(([key, value]) => {
    qs = `${qs}&${key}=${value}`;
  });
  return qs.startsWith("&") ? qs.slice(1) : qs;
};
